"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var KeyBenefits = /** @class */ (function (_super) {
    __extends(KeyBenefits, _super);
    function KeyBenefits() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyBenefits.prototype.render = function () {
        var _this = this;
        // const benefits = ["25% off 4 times a year", "Exclusive sales and offers throughout the year."];
        var benefits = this.props.data.section.account.blocks;
        return (React.createElement("div", { className: this.props.className },
            React.createElement(Snippets.Heading, { size: "h1", className: (this.props.title ? "block" : "hidden") + " " + this.props.titleStyle }, this.props.title),
            benefits.map(function (benefit) {
                var content = benefit.settings.benefit;
                return (React.createElement("div", { key: benefit.id, className: "flex flex-row " },
                    React.createElement(Snippets.Heading, { size: "p", className: _this.props.benefitStyle },
                        React.createElement(Snippets.Svg, { name: "check-circled", height: 24, width: 24, className: "inline mr-1" }),
                        content)));
            })));
    };
    return KeyBenefits;
}(React.PureComponent));
exports.KeyBenefits = KeyBenefits;
